<template>
    <div>
        <div>
            <app-table :id="tableId" :options="options" @action="getListAction" />
        </div>
        <app-confirmation-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="application-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
            title="Confirmación"
            message="¿Desea deshacer este registro?"
        />
    </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";
import { axiosPost } from "@/app/helpers/AxiosHelper";

export default {
    extends: CoreLibrary,
  mixins: [TableHelpers],
  props: {
    tableId: String,
    accAppId: String,
  },
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      rowData: {},
      options: {
        url: `/accreditations/officio/showEditSampling/${this.accAppId}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Deshacer"),
            icon: "trash",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    }
  },
  created() {
    this.options.columns = [
      ...this.tableColumns, this.actionObj];
  },
   methods: {
    getListAction(rowData, actionObj, active) {
        this.rowData = rowData;
      if (actionObj.title == this.$t("Deshacer")) {
        this.openDeleteModal();
      }
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `/accreditations/officio/destroySampling/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#application-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
    },
   }

}
</script>

<style>

</style>